import React from 'react';
import EnterpriseSelectionCard from "../../card/EnterpriseSelectionCard";

function Tutorials(props) {
	return (
		<EnterpriseSelectionCard url="general" />
	);
}

export default Tutorials;